export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__CONNECTION_SCORE': 'Connection Score',
    '____ALIGNMENT': '% Alignment'
};
